import type { ReactElement } from 'react';

import { cn } from './cn';

import { pageWindow } from './page-window';

interface Props {
  page: number;
  pageSize: number;
  total: number;
  busy: boolean;
  onPage: (page: number) => void;
}

/** Paginación por página: "Mostrando X–Y de N" + páginas numeradas + Anterior/Siguiente. */
export function Pagination({ page, pageSize, total, busy, onPage }: Props): ReactElement {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const current = Math.min(page, totalPages);
  const from = total === 0 ? 0 : (current - 1) * pageSize + 1;
  const to = Math.min(current * pageSize, total);
  const rangeText = total === 0 ? 'Sin documentos' : `Mostrando ${from}–${to} de ${total}`;

  return (
    <div className="pagebar">
      <span>{rangeText}</span>
      <div className="pg">
        <button
          type="button"
          className="btn mut sm"
          onClick={() => onPage(current - 1)}
          disabled={busy || current <= 1}
        >
          Anterior
        </button>
        {pageWindow(current, totalPages).map((n) => (
          <button
            key={n}
            type="button"
            className={cn('sm', n === current ? 'btn' : 'btn mut')}
            aria-current={n === current ? 'page' : undefined}
            onClick={() => onPage(n)}
            disabled={busy || n === current}
          >
            {n}
          </button>
        ))}
        <button
          type="button"
          className="btn mut sm"
          onClick={() => onPage(current + 1)}
          disabled={busy || current >= totalPages}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
}
